module.exports = (require("./helpers/browser/css-loader")(parcelRequire.resolve("7xNLC")));